import PendoIcon from '../icon/pendo-icon.vue.js';
import { TRIGGER_SIZE_MAP } from './multiselect-helper.js';

var script = {
  components: {
    PendoIcon
  },
  props: {
    computedPlaceholder: {
      type: [String, Object, Number]
    },
    disabled: {
      type: Boolean
    },
    id: {
      type: String
    },
    inputValue: {
      type: String
    },
    isFullWidth: {
      type: Boolean
    },
    isOpen: {
      type: Boolean
    },
    isSearchIconVisible: {
      type: Boolean
    },
    minTriggerWidth: {
      type: [String, Number]
    },
    showSelectedValueTags: {
      type: Boolean
    },
    shouldAnimateSearchEnterExit: {
      type: Boolean
    },
    triggerSize: {
      type: String
    },
    triggerWidth: {
      type: Number
    },
    updateInputValue: {
      type: Function
    }
  },
  data() {
    const initialMinWidth = parseInt(this.minTriggerWidth) - TRIGGER_SIZE_MAP[this.triggerSize] - 30;
    return {
      inputMinWidth: initialMinWidth,
      inputWidth: initialMinWidth
    };
  },
  computed: {
    inputStyles() {
      if (this.showSelectedValueTags) {
        return null;
      }
      if (this.isFullWidth) {
        return {
          width: `${this.inputWidth}px`
        };
      }
      return {
        minWidth: `${this.inputMinWidth}px`,
        width: `${this.inputWidth}px`
      };
    },
    searchIconTransition() {
      if (this.shouldAnimateSearchEnterExit) {
        return 'pendo-multiselect-search-icon-fade-scale';
      }
      return '';
    },
    searchInputTransition() {
      if (this.shouldAnimateSearchEnterExit) {
        return 'pendo-multiselect-search-input-slide';
      }
      return '';
    }
  },
  mounted() {
    if (this.$refs.input) {
      requestAnimationFrame(() => {
        this.$refs.input.focus();
      });
    }
    this.setInputWidth();
  },
  methods: {
    setInputWidth() {
      if (this.showSelectedValueTags || this.isFullWidth) {
        return;
      }
      const {
        input,
        mirror
      } = this.$refs;
      if (input && mirror && this.isOpen) {
        const {
          fontSize,
          fontFamily,
          fontWeight,
          fontStyle,
          letterSpacing,
          textTransform,
          minWidth,
          maxWidth
        } = window.getComputedStyle(input);
        Object.assign(mirror.style, {
          fontSize,
          fontFamily,
          fontWeight,
          fontStyle,
          letterSpacing,
          textTransform,
          minWidth,
          maxWidth
        });
        const suffixSize = TRIGGER_SIZE_MAP[this.triggerSize] - 2;
        const searchIconSize = this.isSearchIconVisible ? 30 : 0;
        const pixelsNeeded = mirror.getBoundingClientRect().width;
        const availablePixels = this.triggerWidth - suffixSize - searchIconSize;
        if (pixelsNeeded > availablePixels) {
          this.inputWidth = availablePixels;
        } else {
          this.inputWidth = pixelsNeeded;
        }
      }
    },
    beforeLeave(el) {
      el.style.display = 'none';
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-multiselect-input.vue2.js.map
